import React, { Component } from 'react';
import Formulario from './SubirProveedorForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class SubirProveedor extends Component{
    state={
        archivo: null
    }

    componentDidMount = () => {
        const { listarEmpresas } = this.props;
        listarEmpresas();
    }
    
    setArchivo = (archivo) => {
        this.setState({archivo});
    };
    
    subirProveedores = (data) => {
        const { subirProveedores } = this.props;
        subirProveedores( {...data, archivo: null},
        [{ "file": this.state.archivo, "name": 'archivo' },])
    }

    render(){
        const { loader, listarEmpresas } = this.props;
    
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    onSubmit = {this.subirProveedores}
                    listarEmpresas = {listarEmpresas}
                    setArchivo={this.setArchivo} 
                />
            </LoadMask>
        );
    }
}

export default SubirProveedor
